import './ReadonlyNonEmptyArray-0e481d0b.js';

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @since 2.5.0
 */
function fst$1(ea) {
    return ea[0];
}
/**
 * @since 2.5.0
 */
function snd$1(ea) {
    return ea[1];
}

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @since 2.0.0
 */
var fst = fst$1;
/**
 * @since 2.0.0
 */
var snd = snd$1;
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category mapping
 * @since 2.0.0
 */
var bimap = function (f, g) { return function (fa) {
    return [g(fst(fa)), f(snd(fa))];
}; };

export { bimap as b };
//# sourceMappingURL=Tuple-2f69c1c7.js.map
